import React from 'react';
import styles from './Mvv.module.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css'; 

import c1 from '../../../Assets/Clients/Our Clients-01.png';
import c2 from '../../../Assets/Clients/Our Clients-02.png';
import c3 from '../../../Assets/Clients/Our Clients-03.png';
import c4 from '../../../Assets/Clients/Our Clients-04.png';
import c5 from '../../../Assets/Clients/Our Clients-05.png';
import c6 from '../../../Assets/Clients/Our Clients-06.png';
import c7 from '../../../Assets/Clients/Our Clients-07.png';
import c8 from '../../../Assets/Clients/Our Clients-08.png';
import c9 from '../../../Assets/Clients/Our Clients-09.png';
import c10 from '../../../Assets/Clients/Our Clients-10.png';
import c11 from '../../../Assets/Clients/Our Clients-11.png';
import c12 from '../../../Assets/Clients/Our Clients-12.png';
import c13 from '../../../Assets/Clients/Our Clients-13.png';
import c14 from '../../../Assets/Clients/Our Clients-14.png';
import c15 from '../../../Assets/Clients/Our Clients-15.png';
import c16 from '../../../Assets/Clients/Our Clients-16.png';
import c17 from '../../../Assets/Clients/Our Clients-17.png';
import c18 from '../../../Assets/Clients/Our Clients-18.png';
import c19 from '../../../Assets/Clients/Our Clients-19.png';
import c20 from '../../../Assets/Clients/Our Clients-20.png';
import c21 from '../../../Assets/Clients/Our Clients-21.png';
import c22 from '../../../Assets/Clients/Our Clients-22.png';
import c23 from '../../../Assets/Clients/Our Clients-23.png';
import c24 from '../../../Assets/Clients/Our Clients-24.png';
import c25 from '../../../Assets/Clients/Our Clients-25.png';

const Mvv = () => {
  const clientImages = [
      c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15, c16, c17, c18, c19, c20, c21, c22, c23, c24, c25
  ];

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5, slidesToSlide: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 3, slidesToSlide: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 2, slidesToSlide: 1 }
  };

  return (
    <section className={styles.mvv_section}>
      <div className={styles.container}>
        
        {/* ══ 1. Core Principles ══ */}
        <div className={styles.section_header}>
          <h2>Our Core Principles</h2>
          <p>
            As the best marketing company in Pune, our principles drive us to deliver 
            unparalleled digital growth and creative excellence.
          </p>
        </div>

        <div className={styles.mvv_grid}>
          <div className={styles.card}>
            <div className={styles.card_icon}>🚀</div>
            <h3>Our Mission</h3>
            <p>
              To empower brands through innovative digital solutions, delivering transformative 
              marketing campaigns that exceed expectations, foster growth, and drive positive change.
            </p>
          </div>
          <div className={styles.card}>
            <div className={styles.card_icon}>🔭</div>
            <h3>Our Vision</h3>
            <p>
              To become India's pioneering media solutions provider, celebrated for creativity, 
              strategy, and impactful results that redefine success in a competitive landscape.
            </p>
          </div>
          <div className={styles.card}>
            <div className={styles.card_icon}>💎</div>
            <h3>Our Values</h3>
            <p>
              Anchored in innovation, integrity, and collaboration. We prioritize excellence in all 
              our endeavors, ensuring enduring client relationships and measurable ROI.
            </p>
          </div>
        </div>

        {/* ══ 2. Why Choose Us (New Rich Section) ══ */}
        <div className={styles.approach_section}>
          <div className={styles.section_header}>
            <h2>Why Partner With Us?</h2>
            <p>We are more than just an agency. We are your dedicated growth partner in navigating the complex digital ecosystem.</p>
          </div>
          <div className={styles.approach_grid}>
            <div className={styles.approach_card}>
              <div className={styles.approach_num}>01</div>
              <h4>360° Digital Solutions</h4>
              <p>From custom web development to aggressive SEO, social media management, and paid advertising, we provide an all-inclusive marketing umbrella for your brand.</p>
            </div>
            <div className={styles.approach_card}>
              <div className={styles.approach_num}>02</div>
              <h4>Data-Backed Strategies</h4>
              <p>We don't do guesswork. Every campaign is backed by deep analytics, market research, and continuous A/B testing to ensure maximum ROI.</p>
            </div>
            <div className={styles.approach_card}>
              <div className={styles.approach_num}>03</div>
              <h4>Hyper-Local to Global</h4>
              <p>Whether you need to dominate the Pune market or expand globally, our localized and international SEO strategies guarantee top-tier visibility.</p>
            </div>
            <div className={styles.approach_card}>
              <div className={styles.approach_num}>04</div>
              <h4>Award-Winning Support</h4>
              <p>Your success is our priority. Get a dedicated account manager, weekly strategy calls, and 24/7 transparent reporting on your campaign's performance.</p>
            </div>
          </div>
        </div>

        {/* ══ 3. Contact Strip ══ */}
        <div className={styles.contact_strip}>
          <h3>Ready to elevate your brand?</h3>
          <div className={styles.contact_details}>
            <div className={styles.contact_item}>
              <span className={styles.icon}>📞</span>
              <a href="tel:+919922966739">+91 99229 66739</a>
            </div>
            <div className={styles.contact_item}>
              <span className={styles.icon}>✉️</span>
              <a href="mailto:info@yeskondomedia.com">info@yeskondomedia.com</a>
            </div>
          </div>
        </div>

        {/* ══ 4. Clients Section ══ */}
        <div className={styles.clients_section}>
          <h2>Brands That Trust Us</h2>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            keyBoardControl={true}
            customTransition="transform 500ms ease-in-out"
            transitionDuration={500}
            removeArrowOnDeviceType={["tablet", "mobile"]}
          >
            {clientImages.map((src, index) => (
              <div key={index} className={styles.client_logo_wrap}>
                <img src={src} alt={`Yeskondo Client ${index + 1}`} className={styles.client_logo} loading="lazy" />
              </div>
            ))}
          </Carousel>
        </div>

      </div>
    </section>
  );
}

export default Mvv;